<ion-datetime *ngIf="controlName !== undefined; else withoutFormControlName"
  [formControlName]='controlName'

  [color]="color"
  presentation="date"
  [multiple]="multiple"
  [firstDayOfWeek]="firstDayOfWeek"
  [showDefaultTitle]="showDefaultTitle"
  [showClearButton]="showClearButton"
  [max]="max"
  [size]="size"
  [class]="class"
  [highlightedDates]="highlightedDates"
  [value]="value"
  (ionChange)="onDateChange($event)"

  [(ngModel)]="dateSelected"
  >

  <span slot="title">Select one or more dates</span>
</ion-datetime>

<ng-template #withoutFormControlName >
  <ion-datetime
    [color]="color"
    presentation="date"
    [multiple]="multiple"
    [firstDayOfWeek]="firstDayOfWeek"
    [showDefaultTitle]="showDefaultTitle"
    [showClearButton]="showClearButton"
    [max]="max"
    [size]="size"
    [class]="class"
    [highlightedDates]="highlightedDates"
    [value]="value"
    (ionChange)="onDateChange($event)"

    [(ngModel)]="dateSelected"
    >

    <span slot="title">Select one or more dates</span>
  </ion-datetime>
</ng-template>

<!-- define the detail part -> will be repositioned into the ion-datetime component -->
<span part="calendar-details-span" class="calendar-details-span" *ngIf="includeDetails">
  <app-time-expense-details [dates]="dateSelected" [associative]="markedAssociative"></app-time-expense-details>
</span>